// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2_-qj","list":"styles_list__35Swt"};